<template>
  <el-dialog title="添加" :visible.sync="dialogVisible" @close="cancelFunc" :close-on-click-modal="false" :close-on-press-escape="false" width="50%">
    <el-form :model="form"  ref="form" >
      <el-form-item label="选择会员"  prop="user_id" :rules="[{required: true,message: '请选择用户'}]">
        <el-row>
          <el-button @click="addClick" icon="el-icon-plus">选择会员</el-button>
          <div v-if="form.user_id!=''" class="img">
            <img :src="user_info.avatarUrl" width="100" height="100" />
          </div>
          <div>
            会员ID：{{user_info.user_id}}
          </div>
        </el-row>
      </el-form-item>
    </el-form>
     <!--添加-->
    <GetUser :is_open="open_user" @close="closeDialogFunc"></GetUser>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancelFunc">取 消</el-button>
      <el-button type="primary" @click="confirmFunc">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import PlusApi from '@/api/plus.js';
import GetUser from '@/components/user/GetUser.vue';
export default {
  components: {
      /*编辑组件*/
      GetUser
    },
  data() {
    return {
      /*左边长度*/
      formLabelWidth: '100px',
      /*是否显示*/
      dialogVisible: false,
      user_info: {},
      /*表单数据模型*/
      form: {
        user_id:''
      },
       open_user: false,
    };
  },
  props: {
    open_add: Boolean,
  },
  watch: {
    open_add: function(n, o) {
      if (n != o) {
        this.dialogVisible = this.open_add;
      }
    }
  },
  created() {},
  methods: {
    /*添加用户*/
    confirmFunc() {
      let self = this;
      let params ={};
      params.user_id= this.form.user_id;
      self.$refs.form.validate((valid) => {
        if (valid) {
          PlusApi.agentUserAdd(params, true)
            .then(data => {
              self.$message({
                message: '添加成功',
                type: 'success'
              });
              self.cancelFunc(true);
            })
            .catch(error => {});
            }
      });

    },
    /*打开弹出层*/
      addClick() {
        this.open_user = true;
      },

      /*关闭获取用户弹窗*/
      closeDialogFunc(e) {
        if (e.type != 'error') {
          this.user_info = e.params[0];
          this.form.user_id = e.params[0].user_id;
        }
        this.open_user = false;
      },

    /*关闭弹窗*/
    cancelFunc(e) {
      let type='cancel';
      if(e){
        type='success';
      }
      this.$emit('close', {
        type:type
      });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/agent/user/dialog/Add.vue